import React from 'react';

import Tooltip from 'CommonComponents/Tooltip';

export default function TableHeaderWithTooltip({ tooltipContent, content, ...props }) {
    return (
        <th {...props}>
            <Tooltip placement="bottom" tooltipContent={!tooltipContent ? '' : tooltipContent} tooltipType="text" offset={[0, 16]}>
                <div className="tw-cursor-pointer">{content}</div>
            </Tooltip>
        </th>
    );
}
